import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { IAppItem, IMenuItem } from './Modules.Interface';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {

    /** 当前收起状态 */
    public collapsed: boolean = true;

    /** 是否显示应用盒子 */
    public appBoxShow: boolean = false;

    /** 我的APP */
    public myAppList: IAppItem[] = [];

    /** 正在运行的app */
    public runAppKeying?: string;

    public isShowMenu: boolean = false;

    public forceShowMenu: boolean = false;
    //菜单栏模式
    public menuMode: 1 | 2 ; //1:应用模式,;2:分类模式
    /** 菜单 */
    public appMenu: IAppItem[];
    public categoryMenu: Array<any>;
    public helpVisible:boolean = false;
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/Modules.State.ts